var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full col-span-2",class:{
        'border-b-2 border-secondary': _vm.variant === 'underline',
        'p-2 bg-red-500 text-white font-bold': _vm.variant === 'alert',
        'p-2 bg-secondary text-white font-bold': _vm.variant !== 'underline' && _vm.variant !== 'alert',
    },on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default",function(){return [_c('div',{staticClass:"flex w-full items-center"},[(_vm.icon)?_c('icon',{staticClass:"mr-3",attrs:{"name":_vm.icon}}):_vm._e(),(_vm.label)?_c(_vm.tag,{tag:"component"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }